export default function trierParNomCommercial(intervenants) {
  intervenants.sort((a, b) => {
    return a.nomCommercial.localeCompare(b.nomCommercial);
  });
}
